const NAMED_ENTITIES: Readonly<Record<string, string>> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  laquo: '«',
  raquo: '»',
  mdash: '—',
  ndash: '–',
  hellip: '…',
}

const MAX_CODE_POINT = 0x10ffff

const decodeEntity = (entity: string, body: string): string => {
  const isHex = body[0] === '#' && (body[1] === 'x' || body[1] === 'X')
  const isDecimal = body[0] === '#' && !isHex

  if (isHex || isDecimal) {
    const codePoint = Number.parseInt(body.slice(isHex ? 2 : 1), isHex ? 16 : 10)
    return codePoint >= 0 && codePoint <= MAX_CODE_POINT ? String.fromCodePoint(codePoint) : entity
  }

  return NAMED_ENTITIES[body.toLowerCase()] ?? entity
}

// Текст из HTML для мест, где разметка недопустима: meta description, JSON-LD.
// Это не санитайзер — HTML для вывода на страницу чистит server/utils/cms-html.
export const htmlToPlainText = (html: string): string => {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, decodeEntity)
    .replace(/\s+/g, ' ')
    .trim()
}
